import { useState, useEffect } from "react";
import * as Yup from "yup";
import { useForm, SubmitHandler } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { ToastError, ToastSuccess } from "src/components/uiElements/toast";
import {
  ForgotPassword as FORGOT_PASSWORD,
  VerifyOTP as VERIFY_OTP,
} from "src/components/api/forgot_password/forgotPassword";

type ForgotPasswordProps = {
  MobileNumber: string;
  Message: string;
  UserID: number;
  Data: any;
  IsOTPSent: boolean;
  CaptchaToken: string;
};

const UseForgotPasswordScreen = () => {
  const [isShowOTPModal, setIsShowOTPModal] = useState(false);
  const [isPasswordResetSuccess, setIsPasswordResetSuccess] = useState(false);
  const [result, setResult] = useState<ForgotPasswordProps>();
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isResetPasswordSuccess, setResetPasswordSuccess] = useState(false);

  const defaultValues = {
    UserName: "",
    Password: "",
    CaptchaToken: "",
    Device: "Web",
    MobileNumber: "",
  };

  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    MobileNumber: Yup.string()
      .required("Mobile Number is required")
      .length(10, "Mobile number must be 10 digits"),
  });

  const formContext = useForm<ForgotPasswordProps>({
    defaultValues,
    resolver: yupResolver(validationSchema) as any,
  });

  const onSubmit: SubmitHandler<ForgotPasswordProps> = async (values) => {
    setErrorMessage("");
    setIsError(false);
    let inputObj = {
      MobileNumber: values.MobileNumber,
      Device: "WEB",
    };
    let request = JSON.stringify(inputObj);

    setLoading(false);
    const response = await FORGOT_PASSWORD(request);
    setLoading(false);
    if (!response?.isAuthorized) {
      ToastError(response?.data!);
      return;
    }
    if (!response?.status) {
      try {
        let fail_result = JSON.parse(response?.data!);
        ToastError(fail_result.Message);
      } catch (e) {
        ToastError(response?.data! || "An error occurred");
      }
      return;
    }
    try {
      let result: ForgotPasswordProps = JSON.parse(response?.data!);
      if(result.IsOTPSent)
      setIsShowOTPModal(true);
      ToastSuccess(result.Message);
      setResult(result);
    } catch (e) {
      ToastError("Invalid response from server");
      return;
    }
  };
  const verify_OTP = async (values: any): Promise<boolean> => {
    let inputObj = {
      MobileNumber: values.MobileNumber,
      OTP: values.OTP,
      Device: "WEB",
    };

    let request = JSON.stringify(inputObj);

    setLoading(true);

    const response = await VERIFY_OTP(request);

    setLoading(false);
    if (!response?.status) {
      try {
        let failResult = JSON.parse(response?.data!);
        if (failResult.Message === "Invalid OTP") setIsShowOTPModal(true);
        ToastError(failResult.Message);
      } catch (e) {
        ToastError(response?.data! || "An error occurred");
      }
      return false;
    }
    try {
      let result = JSON.parse(response?.data!);
      setIsShowOTPModal(false);
      setIsPasswordResetSuccess(true);
      ToastSuccess(result.Message);
      return true;
    } catch (e) {
      ToastError("Invalid response from server");
      return false;
    }
  
  };

  return {
    loading,
    defaultValues,
    validationSchema,
    formContext,
    result,
    isShowOTPModal,
    isPasswordResetSuccess,
    setIsPasswordResetSuccess,
    errorMessage,
    isError,
    setIsShowOTPModal,
    verify_OTP,
    onSubmit,
  };
};

export default UseForgotPasswordScreen;
